module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('draggable', {
    staticClass: "datum",
    attrs: {
      "drag-data": _vm.datum
    }
  }, [_c('header', [_c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.datum.value))]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_vm._v(_vm._s(_vm.datum.votes))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d2fb6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datum.vue
// module id = 258
// module chunks = 1